export const CREATE_INSTANCE_PARAM = 'createInstance';
export const CREATE_INSTANCE_VALUE = 'true';
export const GITHUB_ACCORDION_ID = '__github__';
